// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"T3-z","dimensionLabel":"U3-z","styleChooserControlWrapper":"V3-z","styleChooserControl":"W3-z","disabled":"X3-z","giftCard":"Y3-z","styleChooserText":"Z3-z"};